<template>
    <div id="payment" style="width: 100%;overflow: hidden"   v-wechat-title="this.title">
        <div style="overflow: hidden; width:100%;margin:20px 0;float: left; padding: 0 20%">
            <div class="box">
                <div class="tb-booth tb-pic tb-s310">
                    <a class="video"><img :src="entity_image" class="picture"></a>
                </div>
                <ul class="tb-thumb">
                    <li  v-for="(item,key) in data.thumb_image"
                        :key="key"
                        :class="thumbActive==key?'thumb-active':''"
                         @mousemove="swicthThumb(key)"
                    >
                        <div class="tb-pic tb-s40">
                            <img :src="item"  width="40" height="40">
                        </div>
                    </li>
                </ul>
            </div>
            <div style="width:465px;float:left;margin-left:25px;">
                <div style="width:100%;font-size:30px;color:#333;margin-top:20px;">{{ data.entity_name }}</div>
                <div style="width:100%;color:#666;margin-top:10px;">
                    <div style="width:65px;float:left;">销量{{ data.sale }}</div>
                    <div id="tel" style="width:115px;border-left:1px solid #ccc;background:url('/images/tel.png') no-repeat 20px 4px;padding-left:40px;float:left;cursor:pointer;">客服电话</div>
                </div>
                <div style="width:1px;height:1px;position:relative;bottom:70px;left:30px;">
                    <div class="tel_v" style="box-shadow: rgb(187, 187, 187) 0px 1px 13px 1px; width: 170px; height: 14px; padding: 12px 0px; position: relative; background: rgb(255, 255, 255); font-size: 14px; text-align: center; line-height: 14px; z-index: 98; display: none;">
                        400 0660 062
                    </div>
                    <div class="tel_v" style="position: relative; background: rgb(255, 255, 255); width: 10px; height: 10px; box-shadow: rgb(187, 187, 187) 2px 2px 5px -1px; transform: rotate(45deg); left: 78px; bottom: 5px; z-index: 99; display: none;"></div>
                </div>
                <div style="width:100%;color:#666;margin-top:20px;"></div>
                <div style="width:100%;border-top:1px solid #eee;margin:30px 0;"></div>
                <table style="border-collapse:collapse;" border="0">
                    <tbody><tr>
                        <td style="width:55px;">价格</td>
                        <td style="color:#EE3531;font-weight:700;font-size:18px;">
                            <span style="font-weight:400;">￥</span>{{ data.price }}<span style="font-weight:400;text-decoration:line-through;color:#999;font-size:13px;margin-left:10px;">￥{{ data.old_price }}</span>
                        </td>
                    </tr>
                    <tr><td colspan="2" style="height:25px;"></td></tr>
                    <tr>
                        <td>数量</td>
                        <td>
                            <InputNumber :max="data.reserve" :min="1" v-model="num"></InputNumber>
                        </td>
                    </tr>
                    <tr><td colspan="2" style="height:35px;"></td></tr>
                    <tr>
                        <td></td>
                        <td>
                            <div id="sj_buy" @click="payment" style="width:140px;height:40px;line-height:40px;background:#EE3531;color:#fff;font-size:16px;text-align:center;border:1px solid #EE3531;border-radius:3px;cursor:pointer;">立即购买</div>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div style="width:100%;float:left;height:60px;background:#F2F2F2;margin:20px 0;">
            <div style="width:280px;margin:0 auto;">
                <div class="sj_cell" :class="sj==0?'sj_cell_sel':''" @click="cjClick(0)">详情介绍</div>
                <div class="sj_cell" :class="sj==1?'sj_cell_sel':''" @click="cjClick(1)">购买须知</div>
                <div style="clear:both;"></div>
            </div>
        </div>
        <div class="cell_detail" v-html="html"></div>
    </div>
</template>

<script>
    export default {
        name: "Payment",
        data(){
            return {
                entity_image:'',
                thumbActive:0,
                num:1,
                sj:0,
                html:''
            }
        },
        methods:{
            swicthThumb(num){
                this.thumbActive = num;
                this.entity_image = this.data.thumb_image[num];
            },
            payment(){
                if(this.$store.getters.getUserInfo.user_name === undefined){
                    let uri = '/pay_confirm?pid='+this.$route.query.pid+'&num='+this.num;
                    this.$store.dispatch('tmpUri',uri);
                    this.$warning('请先登录');
                    this.$router.push({'path':'/login'});
                }else{
                    let obj = this;
                    this.$router.push({'path':'/pay_confirm','query':{pid: obj.$route.query.pid,num:obj.num}});
                }
            },
            cjClick(num){
                this.sj = num;
                this.html = num==0?this.data.entity_desc:this.data.entity_notes;
            }
        },
        mounted(){
            let pid = this.$route.query.pid;
            let obj =  this;
            this.$store.dispatch('shopDetail',pid).then(()=>{
                obj.entity_image=this.$store.getters.getShopDetail.entity_image;
                obj.html=this.$store.getters.getShopDetail.entity_desc;
                this.$LoadingBar.finish();
            })
        },
        computed:{
            data(){
                return this.$store.getters.getShopDetail;
            },
            title(){
                return this.$store.getters.getShopDetail.entity_name;
            }
        }
    }
</script>

<style scoped>
    hr {
        height: 1px;
        border: none;
        border-top: 5px solid #E3E3E3;
    }
    #payment{
        padding-bottom: 60px;
    }
    .box {
        width: 470px;
        margin: 0 auto;
        position: relative;
        float: left;
    }
    .tb-booth {
        border: 1px solid #CDCDCD;
        position: relative;
        z-index: 1;
    }
    .tb-s310, .tb-s310 img {
        height: 352px;
        width: 465px;
        max-height: 352px;
        max-width: 470px;
        vertical-align: middle;
    }
    .tb-s310, .tb-s310 a {
        height: 352px;
        width: 470px;
        display: table-cell;
        text-align: center;
        vertical-align: middle;
    }
    .tb-thumb {
        margin: 10px 105px 10px;
        overflow: hidden;
    }
    .tb-thumb li {
        background: none repeat scroll 0 0 transparent;
        float: left;
        height: 42px;
        margin: 0 6px 0 0;
        overflow: hidden;
        padding: 1px;
    }
    .tb-thumb li div {
        border: 1px solid #CDCDCD;
    }
    .sj_cell {
        width: 140px;
        height: 60px;
        line-height: 60px;
        text-align: center;
        font-size: 15px;
        float: left;
        cursor: pointer;
    }
    .sj_cell_sel{
        font-weight: bold;
    }
    .cell_detail{
        overflow: hidden;
        width: 100%;
        padding: 0 20%;
        text-align: left;
    }
    .thumb-active{
        background: none repeat scroll 0 0 #ff6f3d !important;
        height: 45px !important;
        padding: 2px !important;
    }
</style>